export const instanceOfINavTabItem = (object: any) => {
    return 'to' in object;
};
